// extracted by mini-css-extract-plugin
export default {"grid_item":"card-item_grid_item__oQLuX"};